import { Component, input } from '@angular/core';

@Component({
    selector: 'com-inline-loading',
    templateUrl: './com-inline-loading.component.html',
    styleUrls: ['./com-inline-loading.component.scss'],
    imports: [],
})
export class ComInlineLoadingComponent {
    readonly text = input('Nalagam podatke');

    readonly onlyIcon = input(false);
}
